<h2 class="title m-2">View Documents <em class="ti-close pull-right" style="color: red; cursor: pointer;" (click)="onClose()"></em> </h2>
<ng-container *ngIf="isLoading === false">

<table class="table table-hover" *ngIf="data">
  <thead>
    <tr>

      <th scope="col" class="main-row">S/N</th>
      <th scope="col" class="main-row" *ngFor="let header of data[0]">
        {{ header }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let document of documents; index as i">
      <th scope="row">{{ i + 1 }}</th>
              <ng-container *ngFor="let header of data[0]">
                <td
                *ngIf="
                checkReferences(document[header], header);
                else noCheck
              "
                >
                  {{ document[header] }}
                </td>

                <ng-template #noCheck>
                  <td
                    class="new_data alert alert-danger"
                    matTooltip="{{ header }} not found"
                    [matTooltipPosition]="position.value"
                  >
                    {{ document[header] }}
                  </td>
                </ng-template>
              </ng-container>
    </tr>

  </tbody>
</table>
<div class="acquisition_submit">
  <button class="default_primary-button" (click)="onSubmit()" type="submit">
    Submit
  </button>
</div>
</ng-container>
<cradua-list-spinner
*ngIf="isLoading === true"
>
</cradua-list-spinner>
